import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

/**
 * One-time token migration: clears stale JWT tokens stored by older versions.
 * The current JWT key changed — old tokens will always fail with signature mismatch.
 * We version-stamp the tokens so users get a clean login exactly once.
 */
const TOKEN_VERSION = 'v3'; // increment this whenever the JWT secret changes
const storedVersion = localStorage.getItem('ae_token_version');
if (storedVersion !== TOKEN_VERSION) {
  // Clear all auth data — user will see login screen
  ['ae_access_token','ae_refresh_token','ae_user','ae_admin',
   // Legacy keys from old versions
   'autoelite-user','autoelite-admin','autoelite-bookings',
   'ae_all_bookings','ae_admin_notifs','ae_last_sms',
   'ae_services','ae_brands','ae_parts_brands','ae_stats',
  ].forEach(k => localStorage.removeItem(k));
  localStorage.setItem('ae_token_version', TOKEN_VERSION);
  console.info('[AutoElite] Cleared stale tokens — please sign in again.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);